import React from "react";
import QuestionItem from "../components/QuestionItem";

/**
 * Safety Analysis questions – page index resets to 1 on this page.
 * Single-arm: Q1–Q5 (formerly Q9–Q13 in the unified wizard numbering).
 * Multiple-arm / dose-finding: Q1–Q5 (formerly Q12–Q16).
 *
 * Activators include the flow branch check so that only the correct variant
 * is visible at any time, even though both variants live in the same form.
 */
const SafetyAnalysisQuestions = ({ globalId, wizardForm }) => {
  return (
    <form name={"wizardForm"}>
      {/* ════════════════════════════════════════════════
          SINGLE ARM  (qComparative = false)
          ════════════════════════════════════════════════ */}

      {/* Q1 – safety baseline */}
      <QuestionItem
        questionIndex={"1"}
        questionName={"qSafetyBaseline"}
        activator={
          wizardForm.controls.qComparative.value === "false" ||
          wizardForm.controls.qComparative.value === null
        }
        questionInputType={"text"}
      />
      {/* Q2 – safety endpoint */}
      <QuestionItem
        questionIndex={"2"}
        questionName={"qSafetyEndpoint"}
        activator={
          wizardForm.controls.qComparative.value === "false" ||
          wizardForm.controls.qComparative.value === null
        }
        questionInputType={"text"}
      />
      {/* Q3 – cut-offs for abnormal lab tables */}
      <QuestionItem
        questionIndex={"3"}
        questionName={"qCutOffsForAbnormalLabTables"}
        activator={
          wizardForm.controls.qComparative.value === "false" ||
          wizardForm.controls.qComparative.value === null
        }
        questionInputType={"text"}
      />
      {/* Q4 – cut-offs */}
      <QuestionItem
        questionIndex={"4"}
        questionName={"qCutOffs"}
        activator={
          wizardForm.controls.qComparative.value === "false" ||
          wizardForm.controls.qComparative.value === null
        }
        questionInputType={"radio"}
        questionInputChoice={"qCutOffs"}
        globalId={globalId}
      />
      {/* Q5 – cut-offs for adverse events tables */}
      <QuestionItem
        questionIndex={"5"}
        questionName={"qCutOffsForAdverseEventsTables"}
        activator={
          wizardForm.controls.qComparative.value === "false" ||
          wizardForm.controls.qComparative.value === null
        }
        questionInputType={"text"}
      />

      {/* ════════════════════════════════════════════════
          MULTIPLE ARM & DOSE FINDING  (qComparative = true)
          ════════════════════════════════════════════════ */}

      {/* Q1 – safety baseline */}
      <QuestionItem
        questionIndex={"1"}
        questionName={"qSafetyBaseline"}
        activator={wizardForm.controls.qComparative.value === "true"}
        questionInputType={"text"}
      />
      {/* Q2 – safety endpoint */}
      <QuestionItem
        questionIndex={"2"}
        questionName={"qSafetyEndpoint"}
        activator={wizardForm.controls.qComparative.value === "true"}
        questionInputType={"text"}
      />
      {/* Q3 – cut-offs for abnormal lab tables */}
      <QuestionItem
        questionIndex={"3."}
        questionName={"qCutOffsForAbnormalLabTables"}
        activator={wizardForm.controls.qComparative.value === "true"}
        questionInputType={"text"}
      />
      {/* Q4 – cut-offs */}
      <QuestionItem
        questionIndex={"4"}
        questionName={"qCutOffs"}
        activator={wizardForm.controls.qComparative.value === "true"}
        questionInputType={"radio"}
        questionInputChoice={"qCutOffs"}
        globalId={globalId}
      />
      {/* Q5 – cut-offs for adverse events tables */}
      <QuestionItem
        questionIndex={"5"}
        questionName={"qCutOffsForAdverseEventsTables"}
        activator={wizardForm.controls.qComparative.value === "true"}
        questionInputType={"text"}
      />
    </form>
  );
};

export default SafetyAnalysisQuestions;
